import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { actionsApi } from '../api/actions.api'
import type { CreateActionRequest, UpdateActionRequest } from '@/shared/types/admin'

const ACTIONS_KEY = ['actions']

export function useActions() {
  return useQuery({
    queryKey: ACTIONS_KEY,
    queryFn: actionsApi.getAll,
    select: (data) => [...data].sort((a, b) => a.libelle.localeCompare(b.libelle)),
  })
}

export function useAction(id: number | undefined) {
  return useQuery({
    queryKey: [...ACTIONS_KEY, id],
    queryFn: () => actionsApi.getById(id!),
    enabled: !!id,
  })
}

export function useActionsActifs() {
  return useQuery({
    queryKey: [...ACTIONS_KEY, 'actifs'],
    queryFn: actionsApi.getActifs,
  })
}

export function useCreateAction() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateActionRequest) => actionsApi.create(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ACTIONS_KEY }),
  })
}

export function useUpdateAction() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateActionRequest }) =>
      actionsApi.update(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ACTIONS_KEY }),
  })
}

export function useDeleteAction() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => actionsApi.delete(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ACTIONS_KEY }),
  })
}
